import React, { Component } from "react";
import { convertEnumToArray } from '../../utils/common.util'
import { CurfewOptions} from '../../constants/server.constant'

class FromToTimeline extends Component {

    constructor(props) {
        super(props)
    }

    render() {
        const {
            fromName = '',
            toName = '',
            fromValue = '',
            toValue = '',
            fromHandleChange = () => {
                // Function not implemented yet, placeholder for future functionality.
            },
            toHandleChange = () => {
                // Function not implemented yet, placeholder for future functionality.
            },
            fromErrorText = '',
            toErrorText = '',
            disabled = false
        } = this.props;

      

        return (
            <div className="col-md-6">
                <div className="row">
                    <div className="col-md-6" style={{ marginBottom: 25 }}>
                        <div className="form-group dflex-form" style={{ marginBottom: 0 }}>
                            <select
                                disabled={disabled}
                                name={fromName}
                                value={fromValue}
                                className="form-control border-0"
                                onChange={fromHandleChange}>
                                <option disabled value="">From</option>
                                {
                                    convertEnumToArray(CurfewOptions).slice(1).map((option, index) => (
                                        <option key={index} value={option.value} >{option.label}</option>
                                    ))
                                }
                            </select>
                        </div>
                        <div className="error-message">{fromErrorText}</div>
                    </div>
                    <div className="col-md-6" style={{ marginBottom: 25 }}>
                        <div className="form-group dflex-form" style={{ marginBottom: 0 }}>
                            <select disabled={(disabled || fromValue === '')} name={toName} value={toValue} className="form-control border-0" onChange={toHandleChange} >
                                <option value="" disabled>To</option>
                                {
                                    convertEnumToArray(CurfewOptions).slice(1).map((option, index) => (
                                        <option key={index} value={option.value} >{option.label}</option>
                                    ))
                                }
                            </select>
                        </div>
                        <div className="error-message">{toErrorText}</div>
                    </div>
                </div>
            </div>
        )
    }

}


export default FromToTimeline;